import { getDiscountAmount } from "./get-discount-amount";
import { bigMath } from "./misc";
import { OfferLike, OrderItemInputLike } from "./types";
import { OFFER_TYPE } from "~served/configs/enums";
export const getAppliedOfferByItems = <TOffer extends OfferLike = OfferLike>(
	items: OrderItemInputLike[],
	offer: UndefinedOrNull<TOffer>,
) => {
	const eligibleItems: Record<string, number> = {};

	if (!offer?.configs.length)
		return { offer: null, eligibleItems, offerAmount: 0 };

	// doesnt allow for receipt offer in get offer by items
	if (isReceiptOffer(offer))
		return { offer: null, eligibleItems, offerAmount: 0 };

	items.forEach((orderItem) => {
		const itemTotalPrice = orderItem.subtotal || orderItem.totalPrice || 0;
		const orderItemId = orderItem._id.toString();
		const menuItemId = orderItem.item.toString();
		const menuItemCategoryId = orderItem.category.toString();

		offer.configs.forEach((config) => {
			switch (config.type) {
				case OFFER_TYPE.ITEMS:
					if (config.items.includes(menuItemId)) {
						const { discountAmount } = getDiscountAmount(itemTotalPrice, {
							type: config.discount_type,
							value: config.discount_value,
						});

						if (!eligibleItems[orderItemId]) {
							eligibleItems[orderItemId] =
								discountAmount > itemTotalPrice
									? itemTotalPrice
									: discountAmount;
						} else if (eligibleItems[orderItemId]) {
							if (
								(offer.is_offering_higher_value &&
									discountAmount > eligibleItems[orderItemId]) ||
								(!offer.is_offering_higher_value &&
									discountAmount < eligibleItems[orderItemId])
							) {
								eligibleItems[orderItemId] =
									discountAmount > itemTotalPrice
										? itemTotalPrice
										: discountAmount;
							}
						}
					}
					break;
				case OFFER_TYPE.CATEGORIES:
					if (config.categories.includes(menuItemCategoryId)) {
						const { discountAmount } = getDiscountAmount(itemTotalPrice, {
							type: config.discount_type,
							value: config.discount_value,
						});

						if (!eligibleItems[orderItemId]) {
							eligibleItems[orderItemId] =
								discountAmount > itemTotalPrice
									? itemTotalPrice
									: discountAmount;
						} else if (eligibleItems[orderItemId]) {
							if (
								(offer.is_offering_higher_value &&
									discountAmount > eligibleItems[orderItemId]) ||
								(!offer.is_offering_higher_value &&
									discountAmount < eligibleItems[orderItemId])
							) {
								eligibleItems[orderItemId] =
									discountAmount > itemTotalPrice
										? itemTotalPrice
										: discountAmount;
							}
						}
					}
					break;
				case OFFER_TYPE.ITEM_TYPES:
					if (config.item_types.includes(orderItem.type)) {
						const { discountAmount } = getDiscountAmount(
							orderItem.subtotal || orderItem.totalPrice || 0,
							{
								type: config.discount_type,
								value: config.discount_value,
							},
						);

						if (!eligibleItems[orderItemId]) {
							eligibleItems[orderItemId] =
								discountAmount > itemTotalPrice
									? itemTotalPrice
									: discountAmount;
						} else if (eligibleItems[orderItemId]) {
							if (
								(offer.is_offering_higher_value &&
									discountAmount > eligibleItems[orderItemId]) ||
								(!offer.is_offering_higher_value &&
									discountAmount < eligibleItems[orderItemId])
							) {
								eligibleItems[orderItemId] =
									discountAmount > itemTotalPrice
										? itemTotalPrice
										: discountAmount;
							}
						}
					}
					break;
			}
		});
	});

	return {
		offer,
		eligibleItems,
		offerAmount: Object.values(eligibleItems).reduce(
			(pre, cur) => bigMath.add(pre, cur),
			0,
		),
	};
};

export const getAppliedOfferByReceipt = <TOffer extends OfferLike = OfferLike>(
	amount: number,
	offer: UndefinedOrNull<TOffer>,
) => {
	let offerAmount = 0;

	if (!offer?.configs.length || !amount)
		return { offer: offer ?? null, offerAmount };

	// doesnt allow for other type offer in get offer by receipt
	if (!isReceiptOffer(offer)) return { offer: null, offerAmount };

	offer.configs.forEach((config) => {
		const { discountAmount } = getDiscountAmount(amount, {
			type: config.discount_type,
			value: config.discount_value,
		});
		if (
			(offer.is_offering_higher_value && discountAmount > offerAmount) ||
			(!offer.is_offering_higher_value && discountAmount < offerAmount)
		) {
			offerAmount = discountAmount;
		}
	});

	return {
		offer,
		offerAmount,
	};
};

export const isReceiptOffer = (offer: UndefinedOrNull<OfferLike>) => {
	return (offer?.configs ?? []).some(
		(config) => config.type === OFFER_TYPE.RECEIPTS,
	);
};
